import { apiFetch } from "./client";

export async function listInsuranceCompanies({ search = "", limit = 200, offset = 0 } = {}) {
  const params = new URLSearchParams({
    search: String(search || ""),
    limit: String(limit),
    offset: String(offset),
  });
  const { data } = await apiFetch(`/insurance-companies?${params.toString()}`, { method: "GET" });
  return Array.isArray(data?.items) ? data.items : [];
}

export async function createInsuranceCompany(payload) {
  const { data } = await apiFetch("/insurance-companies", {
    method: "POST",
    body: payload || {},
  });
  return data || {};
}

export async function patchInsuranceCompany(companyId, payload) {
  const id = String(companyId || "").trim();
  const { data } = await apiFetch(`/insurance-companies/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: payload || {},
  });
  return data || {};
}

